import { render, staticRenderFns } from "./UserLinkUsersDialog.vue?vue&type=template&id=3c158a50&scoped=true"
import script from "./UserLinkUsersDialog.vue?vue&type=script&lang=js"
export * from "./UserLinkUsersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c158a50",
  null
  
)

export default component.exports